import { render, staticRenderFns } from "./GroupeUpdate.vue?vue&type=template&id=050de206"
import script from "./GroupeUpdate.vue?vue&type=script&lang=ts"
export * from "./GroupeUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports